import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import { assert } from '../../assert';
import { withValidation } from '../../validations';
import type { AriaAttributesSDKProps, AriaBusySDK } from './types';

const busySDKFactory: CorvidSDKPropsFactory<
  AriaAttributesSDKProps,
  AriaBusySDK
> = ({ setProps, props }) => ({
  get busy() {
    return props.ariaAttributes?.busy;
  },

  set busy(value) {
    setProps({
      ariaAttributes: {
        ...props.ariaAttributes,
        busy: assert.isNil(value) ? undefined : String(value),
      },
    });
  },
});

export const createBusySDK = withValidation(busySDKFactory, {
  type: ['object'],
  properties: {
    busy: {
      type: ['boolean', 'string'],
      enum: ['false', 'true'],
    },
  },
});
